import { render, staticRenderFns } from "./OcupacionComponent.vue?vue&type=template&id=360cf49c&scoped=true"
import script from "./OcupacionComponent.vue?vue&type=script&lang=js"
export * from "./OcupacionComponent.vue?vue&type=script&lang=js"
import style0 from "./OcupacionComponent.vue?vue&type=style&index=0&id=360cf49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360cf49c",
  null
  
)

export default component.exports